import React, { useEffect, useRef } from 'react';
import { mountThemaNotice } from '../../site/thema-report.js';

export default function ThemaNotice({ language = 'en', module = '', level = '' }) {
  const root = useRef(null);
  useEffect(() => mountThemaNotice(root.current, { language, module, level }), [language, module, level]);
  return <aside ref={root} aria-label="TELC Themen" />;
}
